/**
 * 입력·피커 공통 지우기(X) suffix.
 */
import { cn } from '@/shared/lib/utils';
import { X } from 'lucide-react';
import * as React from 'react';

export type ClearFieldButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const ClearFieldButton = React.forwardRef<
  HTMLButtonElement,
  ClearFieldButtonProps
>(({ className, onPointerDown, onClick, 'aria-label': ariaLabel, ...props }, ref) => (
  <button
    {...props}
    ref={ref}
    type="button"
    tabIndex={-1}
    aria-label={ariaLabel ?? '지우기'}
    className={cn(
      'absolute right-2.5 top-1/2 z-10 -translate-y-1/2 rounded-8 p-0.5',
      'text-ruda-text-tertiary transition-colors',
      'hover:bg-ruda-grey-50 hover:text-ruda-text-primary',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
      'disabled:pointer-events-none disabled:opacity-50',
      className,
    )}
    onPointerDown={(event) => {
      event.preventDefault();
      event.stopPropagation();
      onPointerDown?.(event);
    }}
    onClick={(event) => {
      event.preventDefault();
      event.stopPropagation();
      onClick?.(event);
    }}
  >
    <X className="size-3.5" aria-hidden />
  </button>
));
ClearFieldButton.displayName = 'ClearFieldButton';
